import { createFileRoute, useParams } from '@tanstack/react-router';

import { MeasureWorkspace } from '@/features/nis2/components/MeasureWorkspace';
import { getRegisterContent } from '@/features/nis2/components/registers';
import i18n from '@/lib/i18n';

interface MeasureCodeParams {
  measureCode: string;
}

export const Route = createFileRoute('/_authenticated/nis2/measures/$measureCode')({
  beforeLoad: ({ params }) => ({
    getTitle: () =>
      i18n.t('nis2:measureCode.pageTitle', {
        code: (params as MeasureCodeParams).measureCode.toUpperCase(),
      }),
  }),
  component: MeasureDetailRoute,
});

function MeasureDetailRoute() {
  const { measureCode } = useParams({
    from: '/_authenticated/nis2/measures/$measureCode',
  });

  const RegisterContent = getRegisterContent(measureCode);

  return (
    <MeasureWorkspace measureCode={measureCode}>
      <RegisterContent />
    </MeasureWorkspace>
  );
}
